import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import CachedIcon from '@mui/icons-material/Cached';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  onClose?: () => void;
  success: boolean;
  isLoading?: boolean;
  acceptChanges?: () => void;
  statusDescription?: string;
}

function ResultModal({
  open,
  onClose,
  success,
  isLoading = false,
  acceptChanges,
  statusDescription
}: Props) {
  const { t } = useTranslation('global');
  return (
    <Dialog maxWidth="md" onClose={onClose} open={open} fullWidth>
      <DialogTitle marginTop={2} textAlign="center">
        {t('ticket.properties.downloadMassiveDetails')}
      </DialogTitle>
      <DialogContent>
        <Grid justifyContent="center" container>
          <Grid display="flex" flexDirection="column" md={12} item>
            <Typography align="center" component="span">
              <CachedIcon
                sx={{
                  fontSize: 250,
                  color: isLoading
                    ? 'black'
                    : success === true
                    ? 'green'
                    : 'red',
                  animation: isLoading ? 'spin 2s linear infinite' : 'none',
                  '@keyframes spin': {
                    '0%': {
                      transform: 'rotate(360deg)'
                    },
                    '100%': {
                      transform: 'rotate(0deg)'
                    }
                  }
                }}
              />
              {isLoading && (
                <Box>
                  <Typography component="span">
                    {t('configurationComponent.massiveLoad.messages.progress')}:
                  </Typography>
                  <Typography component="p" fontSize={20} fontWeight="bold">
                    {isLoading ? statusDescription : '100%'}
                  </Typography>
                </Box>
              )}
              {!isLoading && success && (
                <Box>
                  <Typography component="p" fontSize={20} fontWeight="bold">
                    {t('common.commonProperties.completed')}
                  </Typography>
                </Box>
              )}
              {!isLoading && !success && (
                <Box>
                  <Typography component="p" fontSize={20} fontWeight="bold">
                    {t('common.commonProperties.anError')}
                  </Typography>
                </Box>
              )}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      {!isLoading && (
        <DialogActions>
          <Stack direction="row" gap={2} justifyContent="center" width="100%">
            <Button
              color="primary"
              onClick={acceptChanges}
              size="large"
              type="button"
              variant="contained"
            >
              {t('common.commonActions.accept')}
            </Button>
          </Stack>
        </DialogActions>
      )}
    </Dialog>
  );
}

export default ResultModal;
